import { render, staticRenderFns } from "./PriceVsForecastedPriceOriginalCurrency.vue?vue&type=template&id=0bea7450&"
import script from "./PriceVsForecastedPriceOriginalCurrency.vue?vue&type=script&lang=js&"
export * from "./PriceVsForecastedPriceOriginalCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports